import { Avatar, Checkbox, ListItem } from '@mui/material';
import { Checkmark, CheckmarkChecked } from 'Images';
import { Fragment } from 'react';

interface ICheckboxList {
  props?: any;
  option: string;
  isSelected: boolean;
  onClickCheckbox?: (value: string) => void;
}

export const CheckboxList = ({
  option,
  isSelected,
  onClickCheckbox,
  ...props
}: ICheckboxList) => {
  const optionId = option.trim().replace(' ', '-');

  return (
    <Fragment key={option}>
      <ListItem
        {...props}
        sx={{
          maxHeight: '40px',
          fontWeight: isSelected ? '700 !important' : '400 !important',
          fontSize: '18px',
          lineHeight: '22px',
          '&:hover': {
            bgcolor: 'primary.shade_100',
            cursor: 'pointer',
          },
          '&.Mui-selected': {
            fontWeight: '400 !important',
            bgcolor: 'primary.shade_100',
          },
        }}
        onClick={() => (onClickCheckbox ? onClickCheckbox(option) : undefined)}
        role='option'
        aria-labelledby={optionId}
      >
        <label htmlFor={optionId}>
          <Checkbox
            aria-labelledby={optionId}
            icon={
              <Avatar
                alt=''
                src={Checkmark}
                sx={{ width: '24px', height: '24px' }}
              />
            }
            checkedIcon={
              <Avatar
                alt=''
                src={CheckmarkChecked}
                sx={{ width: '24px', height: '24px' }}
              />
            }
            checked={isSelected}
          />
          <span id={optionId}>{option}</span>
        </label>
      </ListItem>
    </Fragment>
  );
};
